import { Component } from "react";
import type { ReactNode, ErrorInfo } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  errorMessage: string;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, errorMessage: error.message || "Bilinmeyen bir hata oluştu" };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("[ErrorBoundary] Yakalanan hata:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-white flex items-center justify-center px-6">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 mx-auto mb-6 bg-red-50 rounded-2xl flex items-center justify-center">
              <i className="ri-error-warning-line text-4xl text-red-500" />
            </div>
            <h1 className="text-xl font-bold text-slate-900 mb-2">Bir Hata Oluştu</h1>
            <p className="text-sm text-slate-500 mb-4">
              Uygulama yüklenirken beklenmeyen bir sorun oluştu. Lütfen sayfayı yenileyin veya daha sonra tekrar deneyin.
            </p>
            <details className="text-xs text-slate-400 mb-6 bg-slate-50 rounded-lg p-3 text-left">
              <summary className="cursor-pointer font-medium text-slate-500">Hata detayı</summary>
              <p className="mt-2 break-all">{this.state.errorMessage}</p>
            </details>
            <button
              onClick={() => {
                this.setState({ hasError: false, errorMessage: "" });
                window.location.reload();
              }}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-slate-900 hover:bg-slate-800 text-white text-sm font-semibold rounded-full transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-refresh-line" />
              Sayfayı Yenile
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}